import { render, staticRenderFns } from "./GbbpBannerText.vue?vue&type=template&id=44af41ca"
import script from "./GbbpBannerText.vue?vue&type=script&lang=js"
export * from "./GbbpBannerText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports